























import { defineComponent } from '@vue/composition-api';
import CtaButton from '../buttons/CtaButton.vue';
import { ButtonPalettes } from '../buttons/palettes';
import { Size } from '../constants';

export default defineComponent({
	components: { CtaButton },
	props: {
		confirmLabel: {
			type: String,
			default: '',
		},
		cancelLabel: {
			type: String,
			default: '',
		},
	},
	setup() {
		return {
			buttonSize: Size.LARGE,
			ButtonPalettes,
		};
	},
});
